import Vue from 'vue';
import moment from 'moment';

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(value).format('DD.MM.YYYY');
    }
});

Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment(value).format('DD.MM.YYYY HH:mm:ss');
    }
});

Vue.filter('fromNow', function(value) {
    return moment(value).fromNow();
});
